import FormJaivana from "dashboard_jaivana_v1";
/**
 * @description: CustomAsentarOrdenProduccion
 * @author: Patricia Lopez Sanchez
 * @version: jdesk_1.01.0002
 **/
class CustomAsentarOrdenProduccion extends FormJaivana.form {

    constructor(props) {
        super(props);
        this.initForm                       = this.initForm.bind(this);
        this.gridOptionsComponentes         = Object.assign({}, this.gridOptions);
        this.gridOptionsComponentes1        = Object.assign({}, this.gridOptions);
        this.gridOptionsComponentes2        = Object.assign({}, this.gridOptions);
        this.gridOptionsConsultarModal      = Object.assign({}, this.gridOptions); 
        this.consultar_orden                = this.consultar_orden.bind(this);                          
        this.successConsultarOrden          = this.successConsultarOrden.bind(this);  
        this.procesar                       = this.procesar.bind(this);                          
        this.successProcesar                = this.successProcesar.bind(this);     
        this.creartemporal                  = this.creartemporal.bind(this);                     
        this.successcreartemporal           = this.successcreartemporal.bind(this);                     
        this.mostrartabla                   = this.mostrartabla.bind(this);                     
        this.successmostrartabla            = this.successmostrartabla.bind(this);             
        this.currencyFormatterGeneral       = this.currencyFormatterGeneral.bind(this);
        this.formatNumberSaldo              = this.formatNumberSaldo.bind(this);    
        this.setButtonDelete                = this.setButtonDelete.bind(this);
        this.eliminar                       = this.eliminar.bind(this);
        this.confirmDelete                  = this.confirmDelete.bind(this);
        this.successEliminar                = this.successEliminar.bind(this);       
        this.setButtonModificar             = this.setButtonModificar.bind(this);
        this.Modificar                      = this.Modificar.bind(this);   
        this.saldototal                     = this.saldototal.bind(this);
        this.successSaldoTotal              = this.successSaldoTotal.bind(this);
        this.traerSaldos                    = this.traerSaldos.bind(this);
        this.successtraerSaldos             = this.successtraerSaldos.bind(this);
        this.traerUbicacion                 = this.traerUbicacion.bind(this);
        this.successtraerUbicacion          = this.successtraerUbicacion.bind(this);
        this.abrir_modal                    = this.abrir_modal.bind(this);
        this.calcular_item                  = this.calcular_item.bind(this);
        this.calcular_total                 = this.calcular_total.bind(this);
        this.cargar_factor                  = this.cargar_factor.bind(this);
        this.successcargarFactor            = this.successcargarFactor.bind(this);
        this.traercosto                     = this.traercosto.bind(this);
        this.successtraercosto              = this.successtraercosto.bind(this);
        this.validacionesAgregar            = this.validacionesAgregar.bind(this);
        this.validacionesAgregar2           = this.validacionesAgregar2.bind(this);
        this.sucessValidaciones             = this.sucessValidaciones.bind(this);
        this.successGrabarItem              = this.successGrabarItem.bind(this);
        this.cargarUbicaciones              = this.cargarUbicaciones.bind(this);
        this.successcargarUbicaciones       = this.successcargarUbicaciones.bind(this);
        this.grabarorden                    = this.grabarorden.bind(this);
        this.successGrabarOrden             = this.successGrabarOrden.bind(this);
        this.limpiar                        = this.limpiar.bind(this);
        this.traercodigo                    = this.traercodigo.bind(this);
        this.successTraerDatos              = this.successTraerDatos.bind(this);
        this.comenzo                        = false;
        this.entro                          = false;
    }

    initForm() {
        console.log("Formulario CustomAsentarOrdenProduccion,  @version: jdesk_1.01.0002, @author: Patricia Lopez Sanchez");
        this.codigo_sucursal = JSON.parse(localStorage.getItem('sucursal_ingreso')).codigo_sucursal;
        this.codigo_usuario = JSON.parse(localStorage.getItem('res')).codigo;
        this.getField("codigo_sucursal").setValue(this.codigo_sucursal);
        this.getField("bodega").setDisabled(false);
        this.getField("fecha").setDisabled(true);
        this.getField("agregar").setDisabled(true);
        this.getField("numero").setOnChange(()=>{if(this.getField("numero").getValue() !== ""){
            this.getField("numero").setError(false,"")
            }if(this.comenzo === false){
                this.getField("nombre_articulo").setValue("");
                this.getField("codigo_producto").setValue("");
                this.getField("cantidad").setValue("");
                this.getField("bodega").setValue("");
                this.getField("unidad").setValue("");
                this.getField("nombre_bodega").setValue("");
                this.getField("consultar").setDisabled(false);
                this.getField("agregar").setDisabled(true);
                this.getField("asentar_orden").setDisabled(true);
                this.limpiar();
            }
        });
        this.getField("numero").setOnBlur(()=>{
            if(this.getField("numero").getValue() !== ""){
                this.getField("numero").setError(false,"")
            }
            if(this.comenzo === true && this.numero_entrada !== this.getField('numero').getValue()){
                this.getField('confirmModalCustom').setTitleAndContent('Consultar Orden de Producción', '¿Desea consultar el número de orden '+ this.getField("numero").getValue()+'?');
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.consultar_orden();
                });
                this.getField('confirmModalCustom').setClickCancelDialog(() => {
                    this.getField('confirmModalCustom').toggle(false);
                    this.getField("numero").setValue(this.numero_entrada);
                });
                this.getField("confirmModalCustom").setVisibleCancel(false);
                this.getField("confirmModalCustom").setButtonConfirm(`Aceptar`);
                this.getField("confirmModalCustom").setButtonCancel(`Cancelar`);
                this.getField('confirmModalCustom').toggle(true);
            }else if(this.numero_entrada !== this.getField('numero').getValue()){
                this.consultar_orden();
            }
        });
        this.getField("agregar").setClick(()=>{this.getField("modal_articulos").handleClickOpen(); this.accion="agregar";this.abrir_modal()});
        this.getField("grabar_agregar").setClick(this.validacionesAgregar);
        this.getField("nombre_sucursal").setOnChange(()=>{if(this.getField("nombre_sucursal").getValue() !== ""){
                this.getField("nombre_sucursal").setError(false,"")
            }else if(this.comenzo === true){
                this.getField("bodega").setDisabled(false);
                this.getField("consultar").setDisabled(false);
                this.getField("agregar").setDisabled(true);
                this.getField("asentar_orden").setDisabled(true);
                this.limpiar();
            }else if(this.getField("nombre_sucursal").getValue() === ""){
                this.getField("bodega").setDisabled(false);
                this.getField("consultar").setDisabled(false);
                this.getField("agregar").setDisabled(true);
                this.getField("asentar_orden").setDisabled(true);
                this.limpiar();
            }
        });

        this.getField("unidad").setOnBlur(()=>{if(this.getField("unidad").getValue() !== ""){
                this.getField("unidad").setError(false,"")
            }
            if(this.comenzo === true && this.unidad !== this.getField('unidad').getValue()){
                this.getField('confirmModalCustom').setTitleAndContent('Unidades Finales Producidas', 'Está a punto de cambiar las unidades: '+this.unidad+' por '+ this.getField("unidad").getValue()+'. Tenga en cuenta que si ya tiene ítems agregados diferentes a los que trae la orden, estos se van a descartar.');
                this.getField('confirmModalCustom').setClickDialog(() => {
                    this.getField('confirmModalCustom').toggle(false);
                    this.getField("bodega").setDisabled(false);
                    this.getField("consultar").setDisabled(false);
                    this.getField("agregar").setDisabled(true);
                    this.getField("asentar_orden").setDisabled(true);
                    this.limpiar();
                });
                this.getField('confirmModalCustom').setClickCancelDialog(() => {
                    this.getField('confirmModalCustom').toggle(false);
                    this.getField("unidad").setValue(this.unidad);
                });
                this.getField("confirmModalCustom").setVisibleCancel(false);
                this.getField("confirmModalCustom").setButtonConfirm(`Aceptar`);
                this.getField("confirmModalCustom").setButtonCancel(`Cancelar`);
                this.getField('confirmModalCustom').toggle(true);
            }
        });

        this.getField("factor").setOnBlur(()=>{
            if(this.getField("nombre_articulo1").getValue() !== ""){
                this.getField("cantidad_unidad1").setValue(this.getField("cantidad_unidad").getValue());
                this.calcular_item();
            }
        });
        this.getField("cantidad_total").setOnChange(()=>{
            if(this.getField("nombre_articulo1").getValue() !== ""){
                this.getField("cantidad_tota1").setValue(this.getField("cantidad_total").getValue());
                this.calcular_total();
            }
        });
        this.getField("nombre_articulo1").setOnChange(()=>{
            if(this.getField("nombre_articulo1").getValue() !== "" ){
                this.getField("nombre_articulo1").setError(false,"")
            }
            if(this.getField("nombre_articulo1").getValue() !== "" && this.entro === false){
                this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está grabando la información... `);
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
                this.abrir_modal();
            }else{
                this.limpiarcampo();
            }
        });
        this.getField('cancelar_agregar').setClick(()=>{
            this.getField('modal_articulos').handleClose()
            this.limpiarcampos();
            this.mostrartabla();
        });
        this.getField("asentar_orden").setDisabled(true);

        this.creartemporal();
        this.getField('consultar').setClick(this.procesar);
        this.getField('factura_compra').setValue("999999");
        this.getField('modal_articulos').setCloseButton(()=>{
            this.limpiarcampos();
            this.mostrartabla();
        });

        this.getField("asentar_orden").setClick(()=>{
            if(this.getField("codigo_sucursal").valid() && this.getField("nombre_sucursal").valid() 
            && this.getField("codigo_producto").valid() && this.getField("nombre_articulo").valid() && this.getField("cantidad").valid()
            && this.getField("bodega").valid() && this.getField("nombre_bodega").valid() && this.getField("unidad").valid() 
            && this.getField("total").valid() && this.getField("factura_compra").valid() && this.getField("nit").valid()
            && this.getField("sede").valid() && this.getField("nombre").valid()){
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', '¿Confirma que desea asentar esta orden de producción?');
                this.getField('confirmModalCustom').setClickDialog(() => {this.grabarorden()});
                this.getField("confirmModalCustom").setVisibleCancel(false); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("Confirmar"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }
        });
        this.getField("nombre_articulo").setOnChange(()=>{
            if(this.comenzo === true){
                this.limpiar();
            }
        });

        this.getField('select_ubicacion').setOnChange(()=>{
            if(this.getField('select_ubicacion').getValue() === ''){
                this.getField('ubicacion').setValue("");
            }
        });
    }

    limpiarcampo(){
        this.getField("nombre_articulo1").setError(false,"");
        this.getField("costo").setValue(0);
        this.getField("cantidad_unidad").setValue(0);
        this.getField("factor").setValue(0);
        this.getField("cantidad_total").setValue(0);
        this.getField("valor_item").setValue(0);
        this.getField("valor_item").setError(false,"");
        if(this.wms_bodega === "S" && this.wms_nuevo==="S"){
            this.getField("ubicacion").setError(false,"");
            this.getField("ubicacion").setValue("");
            let opciones = [{'text':'Ninguno','value':'','campos_cambian':{}}];
            this.getField('select_ubicacion').setOptions(opciones);  
            this.getField('select_ubicacion').setValue('');     
            this.getField("select_ubicacion").setError(false,"");
        }else{
            this.getField("ubicacion").setValue("999999999999"); 
            this.getField('select_ubicacion').setValue('');
        }  
        this.gridOptionsComponentes1['rowData'] = [];
        this.getField('rejilla_bodega').toggle(false);
        this.gridOptionsComponentes2['rowData'] = [];
        this.getField('rejilla_ubicacion').toggle(false);
    }

    creartemporal(){
        let datos={ datos: {
            codigo_usuario:this.codigo_usuario
        }};
        this.generalFormatPmv = { tipo_servicio: 'inve-asentarordenproduccion', operacion: 'creartemp', operacion_tipo: 'consulta' };
        this.service.send(
        {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successcreartemporal,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage:false
        });
    }

    successcreartemporal(data){
        if(data.estado_p === 502){
            this.alertGeneral.toggle(true, 'Error al crearla tabla.', 'error');
        }else{
            this.mostrartabla();
        }
    }

    mostrartabla(){
        let datos={ datos: {
            codigo_usuario:this.codigo_usuario
        }};
        this.generalFormatPmv = { tipo_servicio: 'inve-asentarordenproduccion', operacion: 'mostrartabla', operacion_tipo: 'consulta' };
        this.service.send(
        {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successmostrartabla,
                error: this.error_,
                general: this.generalFormatPmv
        });
    }

    successmostrartabla(data){
        if(data.estado_p === 200){
            this.gridOptionsComponentes['rowData'] = [];
            this.getField('rejilla').toggle(true);
            let configCell = new Map();
            configCell.set('factor', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.factor.toFixed(4)) }, cellStyle: {textAlign:"right"},width: 110});            
            configCell.set('cantxund', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cantxund.toFixed(4)) }, cellStyle: {textAlign:"right"},width: 110});            
            configCell.set('cant_presupuestada', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cant_presupuestada.toFixed(4)) }, cellStyle: {textAlign:"right"},width: 110});            
            configCell.set('cant_utilizada', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.cant_utilizada.toFixed(4)) }, cellStyle: {textAlign:"right"},width: 110});            
            configCell.set('costo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.costo.toFixed(4)) }, cellStyle: {textAlign:"right"},width: 110});            
            configCell.set('costo_item', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.costo_item.toFixed(4)) }, cellStyle: {textAlign:"right"},width: 110});            
            configCell.set('eliminar', { cellRenderer: this.setButtonDelete, width: 110, sortable: false, filter: false, field: 'Eliminar' });
            configCell.set('modificar', { cellRenderer: this.setButtonModificar, width: 110, sortable: false, filter: false, field: 'Modificar' });

            this.gridOptionsComponentes['rowData'] = data.data;
            this.getField('rejilla').initData(this.gridOptionsComponentes, configCell);

        }else if(data.estado_p ===404){
            this.getField("bodega").setDisabled(false);
            this.alertGeneral.toggle(true, 'No hay datos.', 'error');
        }else{
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error '+respuesta, 'error');
        }
    }

    currencyFormatterGeneral(number)
    {
            let decimal = (number + "").split(".")[1];//para manejar los decimales
             if ((decimal !== 0) && (decimal !== undefined)) {
             return (this.formatNumberSaldo(number) + "," + decimal);
             } else {
             return this.formatNumberSaldo(number); }
    }

    formatNumberSaldo(number)
    {
            return Number(number).toString().split('.')[0]
             .toString()
             .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
    }


        
    setButtonDelete(props) {
        if(props.data.codigo !== "."){
            let codigo_articulo = props.data.codigo;
            let button = document.createElement("input");
            button.onclick = () => this.eliminar(codigo_articulo);
            button.setAttribute("codigo_articulo", 'button_delete_' + codigo_articulo);
            button.setAttribute("class", "buttonStyle");
            button.setAttribute("type", "button");
            button.setAttribute("value", "eliminar");
            return this.createElementJaivana(button);
        }
    }

    eliminar(codigo_articulo) {
        this.codigo_articulo = codigo_articulo;
        this.getField('confirmModalCustom').setTitleAndContent('Eliminar', 'Desea realizar esta operación?');
        this.getField('confirmModalCustom').setClickDialog(this.confirmDelete);
        this.getField('confirmModalCustom').setButtonConfirm('Confirmar');
        this.getField("confirmModalCustom").setVisibleCancel(false);
        this.getField('confirmModalCustom').toggle(true);
    }

    confirmDelete() {
        this.getField('confirmModalCustom').toggle(false);
        let datos = {
            datos: {
                codigo_producto: this.codigo_articulo,
                numero: this.getField("numero").getValue(),
                codigo_usuario:this.codigo_usuario
            }
        };
        this.generalFormatPmv = { tipo_servicio: 'inve-asentarordenproduccion', operacion: 'eliminar_articulo', operacion_tipo: "eliminar" };// parametros del servicio
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method: 'DELETE',
            body: datos,
            success: this.successEliminar,
            error: this.error_,
            general: this.generalFormatPmv //se envia el generales de arriba
        });
    }

    successEliminar(data) {
        if(data.estado_p === 200){
            this.gridOptionsComponentes['rowData'] = [];
            this.getField('rejilla').initData(this.gridOptionsComponentes);
            this.mostrartabla();
            this.saldototal();
        }else{
          let keys=Object.keys(data.data.mensaje);
          this.alertGeneral.toggle(true, 'Error (mensaje)' +keys, 'error');
        }
    }

    setButtonModificar(props) {
        if(props.data.codigo !== "."){
            let codigo = props.data.codigo;
            let nombre = props.data.nombre;
            let factor = props.data.factor;
            let cantxund = props.data.cantxund;
            let cantidad_total = props.data.cant_utilizada;
            let costo = props.data.costo;
            let costo_item = props.data.costo_item;
            let ubicacion = props.data.ubicacion;
            let button = document.createElement("input");
            button.onclick = () => this.Modificar(codigo,nombre,factor,cantxund,cantidad_total,costo,costo_item,ubicacion);
            button.setAttribute("codigo", 'button_delete_' + codigo);
            button.setAttribute("class", "buttonStyle");
            button.setAttribute("type", "button");
            button.setAttribute("value", "Modificar");
            return this.createElementJaivana(button);
        }
    }

    Modificar(codigo,nombre,factor,cantxund,cant_utilizada,costo,costo_item,ubicacion) {
        this.getField('confirmModalCustom').toggle(false);
        this.accion="modificar";
        this.getField("modal_articulos").handleClickOpen();
        this.getField("codigo_articulo").setValue(codigo);
        this.getField("nombre_articulo1").setValue(nombre);
        this.getField("codigo_articulo").setDisabled(true);
        this.entro=false;
        this.getField("costo").setValue(costo);
        this.getField("cantidad_unidad").setValue(cantxund);
        this.getField("factor").setValue(factor);
        this.getField("cantidad_total").setValue(cant_utilizada);
        this.getField("valor_item").setValue(costo_item);
        this.getField("ubicacion").setValue(ubicacion);
        this.traerSaldos();
        this.cargarUbicaciones();
    }

    consultar_orden(){
        this.numero_entrada = this.getField("numero").getValue();
        if(this.getField("codigo_sucursal").valid() && this.getField("nombre_sucursal").valid() &&
            this.getField("numero").valid()){
            let datos = { datos: {
                codigo_sucursal:this.getField("codigo_sucursal").getValue(),
                codigo_usuario:this.codigo_usuario,
                numero:this.getField("numero").getValue()
            }};
            
            this.generalFormatPmv = { tipo_servicio: 'inve-asentarordenproduccion', operacion: 'consultar_orden', operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successConsultarOrden,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
        }
    }

    successConsultarOrden(data){
        if(data.estado_p === 200){
            this.getField('confirmModalCustom').toggle(false);
            this.getField("bodega").setValue("");
            this.getField("unidad").setValue("");
            this.getField("nombre_bodega").setValue("");
            this.getField("codigo_producto").setValue(data.data[0].producto);
            this.getField("nombre_articulo").setValue(data.data[0].nombre);
            let cantidad = data.data[0].cantidad_presupuestada.toFixed(1);
            this.getField("cantidad").setValue(cantidad);
            let fecha = data.data[0].fecha_ini.split('T')[0];
            this.getField("fecha").setValue(fecha);
        }else if(data.estado_p ===404){
            this.getField("cantidad").setValue("");
            this.getField("codigo_producto").setValue("");
            this.getField("nombre_articulo").setValue("");
            this.getField("bodega").setValue("");
            this.getField("unidad").setValue("");
            this.getField("nombre_bodega").setValue("");
            if(data.data.existe === "1"){
                this.numero_entrada="";
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La orden de producción con el número '+this.getField("numero").getValue() +' ya ha sido asentada.');
                this.getField('confirmModalCustom').setClickDialog(() => {this.getField("numero").setValue(""); this.getField('confirmModalCustom').toggle(false);});
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("Confirmar"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }else{
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'No existe una orden de producción con el número '+this.getField("numero").getValue() +' para la sucursal '+this.getField("codigo_sucursal").getValue());
                this.getField('confirmModalCustom').setClickDialog(() => {this.getField("numero").setValue(""); this.getField('confirmModalCustom').toggle(false);});
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("Confirmar"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }
            this.getField("bodega").setDisabled(false);
            this.getField("consultar").setDisabled(false);
            this.getField("agregar").setDisabled(true);
            this.getField("asentar_orden").setDisabled(true);
            this.limpiar();
        }else{
            this.alertGeneral.toggle(true, 'Error '+data.data.errores, 'error');
            this.limpiar();
        }
        this.getField("bodega").setDisabled(false);
        this.getField("consultar").setDisabled(false);
        this.getField("agregar").setDisabled(true);
        this.getField("asentar_orden").setDisabled(true);
    }

    procesar(){
        if(this.getField("codigo_sucursal").valid() && this.getField("nombre_sucursal").valid() &&
            this.getField("numero").valid() && this.getField("bodega").valid() && this.getField("nombre_bodega").valid() 
            && this.getField("unidad").valid() ){
            let datos = { datos: {
                sucursal: this.codigo_sucursal,
                codigo_sucursal:this.getField("codigo_sucursal").getValue(),
                codigo_usuario:this.codigo_usuario,
                bodega:this.getField("bodega").getValue(),
                numero:this.getField("numero").getValue()
            }};
            
            this.generalFormatPmv = { tipo_servicio: 'inve-asentarordenproduccion', operacion: 'insertaritems', operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successProcesar,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage:false
            });
        }
    }

    successProcesar(data){
        if(data.estado_p === 200){
            this.comenzo = true;
            this.unidad =this.getField("unidad").getValue();
            this.getField("bodega").setDisabled(true);
            this.wms_bodega= data.data.bodega_wms;
            this.exigefactura= data.data.exigefactura;
            this.wms_nuevo= data.data.wms_nuevo;
            this.lasucursal= data.data.lasucursal;
            this.destino= data.data.destino;
            this.costo_promedio_linea= data.data.costo_promedio_linea;
            this.costo_bodega= data.data.costo_bodega;
            this.mostrartabla();
            this.saldototal();
            this.getField("consultar").setDisabled(true);
            this.getField("agregar").setDisabled(false);
            this.getField("asentar_orden").setDisabled(false);
        }else if(data.estado_p ===404){
            this.alertGeneral.toggle(true, data.data.errores, 'error');
        }else{
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error '+respuesta, 'error');
        }
    }

    saldototal(){
        let datos = { datos: {
            codigo_usuario:this.codigo_usuario
        }};
        
        this.generalFormatPmv = { tipo_servicio: 'inve-asentarordenproduccion', operacion: 'saldo_total', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successSaldoTotal,
            error: this.error_,
            general: this.generalFormatPmv
        });
    }

    successSaldoTotal(data){
        if(data.estado_p === 200){
            this.total = data.data[0].valor;
            this.getField("total").setValue(this.currencyFormatterGeneral(data.data[0].valor));
        }else if(data.estado_p ===404){
            this.alertGeneral.toggle(true, 'No hay datos.', 'error');
        }else{
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error '+respuesta, 'error');
        }
    }

    limpiarcampos(){
        this.getField("codigo_articulo").setDisabled(false);
        this.getField("codigo_articulo").setValue("");
        this.getField("nombre_articulo1").setValue("");
        this.getField("costo").setValue(0);
        this.getField("cantidad_unidad").setValue(0);
        this.getField("factor").setValue(0);
        this.getField("cantidad_total").setValue(0);
        this.getField("valor_item").setValue(0);
        this.getField("cantidad_unidad1").setValue(0);
        this.getField("cantidad_tota1").setValue(0);
        this.getField("valor_item1").setValue(0);
        this.getField("valor_item").setError(false,"");
        if(this.wms_bodega === "S" && this.wms_nuevo==="S"){
            this.getField("ubicacion").setValue("");
            let opciones = [{'text':'Ninguno','value':'','campos_cambian':{}}];
            this.getField('select_ubicacion').setOptions(opciones);  
            this.getField('select_ubicacion').setValue('');
        }else{
            this.getField("ubicacion").setValue("999999999999"); 
            this.getField('select_ubicacion').setValue('');
        }   
        this.gridOptionsComponentes1['rowData'] = [];
        this.getField('rejilla_bodega').toggle(false);
        this.gridOptionsComponentes2['rowData'] = [];
        this.getField('rejilla_ubicacion').toggle(false);
    }

    traerSaldos(){
        let datos = { datos: {
            bodega:this.getField("bodega").getValue(),
            codigo_sucursal:this.lasucursal,
            codigo_articulo:this.getField("codigo_articulo").getValue()
        }};
        
        this.generalFormatPmv = { tipo_servicio: 'inve-asentarordenproduccion', operacion: 'traersaldos', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successtraerSaldos,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage:false
        });
    }

    successtraerSaldos(data){
        if(data.estado_p === 200){
            this.gridOptionsComponentes1['rowData'] = [];
            this.getField('rejilla_bodega').toggle(true);
            let configCell = new Map();
            configCell.set('saldo', {cellRenderer:(props) => {return ""+this.currencyFormatterGeneral(props.data.saldo.toFixed(4)) }, cellStyle: {textAlign:"right"},width: 110});
            this.gridOptionsComponentes1['rowData'] = data.data.saldo_bodegas;
            this.getField('rejilla_bodega').initData(this.gridOptionsComponentes1, configCell);
            this.traerUbicacion();
        }else if(data.estado_p ===404){
            this.alertGeneral.toggle(true, 'No hay datos.', 'error');
        }else{
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error '+respuesta, 'error');
        }
    }

    traerUbicacion(){
        let datos = { datos: {
            bodega:this.getField("bodega").getValue(),
            codigo_sucursal:this.lasucursal,
            codigo_articulo:this.getField("codigo_articulo").getValue(),
            bodega_wms:this.wms_bodega,
            wms_nuevo:this.wms_nuevo
        }};
        
        this.generalFormatPmv = { tipo_servicio: 'inve-asentarordenproduccion', operacion: 'traerubicacion', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successtraerUbicacion,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage:false
        });
    }

    successtraerUbicacion(data){
        if(data.estado_p === 200 && data.data.saldos_ubicacion.length>0){
            this.getField('rejilla_ubicacion').toggle(true);
            this.gridOptionsComponentes2['rowData'] = [];
            let configCell = new Map();
            configCell.set('saldo', {cellRenderer:(props) => { return ""+this.currencyFormatterGeneral(props.data.saldo)}, cellStyle: {textAlign:"right"},width: 110});
            this.gridOptionsComponentes2['rowData'] = data.data.saldos_ubicacion;
            this.getField('rejilla_ubicacion').initData(this.gridOptionsComponentes2, configCell);
        }else if(data.estado_p ===404){
            let respuesta=data.data.errores.mensaje;
            this.alertGeneral.toggle(true, 'Error '+respuesta, 'error');
        }else{
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error '+respuesta, 'error');
        }
    }

    abrir_modal(){
        
        this.getField("codigo_articulo").setDisabled(false);
        this.getField("nombre_articulo1").setDisabled(false);

        if(this.accion==="agregar" && this.getField("nombre_articulo1").getValue() !== ""){
            this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está grabando la información... `);
            this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
            this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
            this.getField('confirmModalCustom').toggle(true);

            this.traerSaldos();
            this.cargar_factor(); 
            if(this.wms_bodega === "S" && this.wms_nuevo==="S"){
                this.cargarUbicaciones();
            }
        }else if(this.accion === "modificar"){
            this.traercodigo();
        }else{
            this.getField("costo").setValue(0);
            this.getField("costo").setError(false,"");
            this.getField("cantidad_unidad").setValue(0);
            this.getField("cantidad_unidad").setError(false,"");
            this.getField("factor").setValue(0);
            this.getField("factor").setError(false,"");
            this.getField("cantidad_total").setValue(0);
            this.getField("cantidad_total").setError(false,"");
            this.getField("valor_item").setValue(0);
            this.getField("valor_item").setError(false,"");

            if(this.wms_bodega === "S" && this.wms_nuevo==="S"){
                this.getField("ubicacion").setDisabled(true);
                this.getField("select_ubicacion").setDisabled(false);
                this.getField("ubicacion").setValue("."); 
            }else{
                this.getField("ubicacion").setValue("999999999999"); 
                this.getField("ubicacion").setDisabled(false);
                this.getField("select_ubicacion").setDisabled(true);
            }
            this.getField("valor_item").setError(false,"");

        }
    }

    calcular_item() {
        //calular el valor del item
        
        let xcosto = this.getField("costo").getValue();
        let xcantidad = this.getField("cantidad_unidad1").getValue();
        let xfactor = this.getField("factor").getValue();
        //Armar los calculos
        let xcosto1 = 0.0, xcantidad1 = 0.0;
        let xfactor1 = 1.0;
        let xcanttotal = 0.0;
        let xvalor_item = 0.0;
        xfactor1 =xfactor;
        xcantidad1 = xcantidad;
        xcosto1 = xcosto;
        xcanttotal = this.getField("unidad").getValue() * xfactor1 * xcantidad1;
        xvalor_item = xcanttotal * xcosto1;

        this.getField("cantidad_total").setValue(Number.parseFloat(xcanttotal.toFixed(4)));
        this.getField("cantidad_total").setError(false,"");
        this.getField("valor_item").setValue(Number.parseFloat(xvalor_item.toFixed(4)));
        this.getField("cantidad_tota1").setValue(Number.parseFloat(xcanttotal.toFixed(4)));
        this.getField("valor_item1").setValue(Number.parseFloat(xvalor_item.toFixed(4)));
        if(this.getField("valor_item").valid()){
            this.getField("valor_item").setError(false,"");
        }
    }


    calcular_total() {
        //calular el valor del item
        
        let xcosto = this.getField("costo").getValue();
        let xcantidad_total = this.getField("cantidad_tota1").getValue();
        let xfactor = this.getField("factor").getValue();

        console.log(xcantidad_total);

        //Armar los calculos
        let xcosto1 = 0.0, xcantidad1 = 0.0;
        let xfactor1 = 1.0;
        let xcanttotal = 0.0;
        let xvalor_item = 0.0;

        xfactor1 =xfactor;
        xcanttotal = xcantidad_total;
        xcosto1 = xcosto;

        console.log(xcanttotal);
        console.log(xcosto1);

        xcantidad1 = xcanttotal/(this.getField("unidad").getValue() * xfactor1);
        xvalor_item = xcanttotal * xcosto1;

        console.log(xcantidad1);
        console.log(xvalor_item);
        
        this.getField("cantidad_unidad").setValue(Number.parseFloat(xcantidad1.toFixed(4)));
        this.getField("cantidad_unidad").setError(false,"");
        this.getField("valor_item").setValue(Number.parseFloat(xvalor_item.toFixed(4)));
        this.getField("cantidad_unidad1").setValue(Number.parseFloat(xcantidad1.toFixed(4)));
        this.getField("valor_item1").setValue(Number.parseFloat(xvalor_item.toFixed(4)));
        if(this.getField("valor_item").valid()){
            this.getField("valor_item").setError(false,"");
        }
        
    }

    cargar_factor(){
        let datos = { datos: {
            codigo_articulo:this.getField("codigo_articulo").getValue(),
            codigo_producto:this.getField("codigo_producto").getValue()
        }};
        
        this.generalFormatPmv = { tipo_servicio: 'inve-asentarordenproduccion', operacion: 'cargarfactor', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successcargarFactor,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage:false
        });
    }

    successcargarFactor(data){
        this.traercosto();
        if(data.estado_p === 200){
            this.getField("cantidad_unidad").setValue(data.data[0].cantidad);
            this.getField("factor").setValue(data.data[0].factor);
        }else if(data.estado_p ===404){
            this.alertGeneral.toggle(true, 'No hay datos.', 'error');
        }else{
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error '+respuesta, 'error');
        }
    }

    traercosto(){
        let datos = { datos: {
            bodega:this.getField("bodega").getValue(),
            codigo_sucursal:this.codigo_sucursal,
            codigo_articulo:this.getField("codigo_articulo").getValue()
        }};
        
        this.generalFormatPmv = { tipo_servicio: 'inve-asentarordenproduccion', operacion: 'traercosto', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successtraercosto,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage:false
        });
    }

    successtraercosto(data){
        this.traercodigo();
        if(data.estado_p === 200){
            this.getField("costo").setValue(data.data.costo);
            this.getField("costo").setError(false,"");
            this.getField("cantidad_unidad").setValue("1,0000");
            this.getField("cantidad_unidad").setError(false,"");
            this.getField("factor").setValue(1);
            this.getField("factor").setError(false,"");
            this.getField("cantidad_total").setError(false,"");
            this.getField("valor_item").setValue(0);
            this.getField("valor_item").setError(false,"");
        }else if(data.estado_p ===404){
            let respuesta=data.data.errores;
            this.alertGeneral.toggle(true, 'Error '+respuesta, 'error');
        }else{
            let respuesta=Object.values(data.data.errores);
            this.alertGeneral.toggle(true, 'Error '+respuesta, 'error');
        }
    }

    validacionesAgregar(){
        if(this.getField("codigo_articulo").valid() && this.getField("nombre_articulo1").valid() && this.getField("costo").valid()
        && this.getField("cantidad_unidad").valid() && this.getField("factor").valid() && this.getField("cantidad_total").valid()
        ){
            if(this.getField("ubicacion").valid()){
                if(this.wms_bodega === "S" && this.wms_nuevo === "S"){
                    if(this.getField("select_ubicacion").valid()){
                        this.getField('grabar_agregar').setDisabled(true);
                        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está validando la información... `);
                        this.getField('confirmModalCustom').setClickDialog(()=>{});  
                        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                        this.getField('confirmModalCustom').toggle(true);
                        let datos={ datos: {
                            codigo_sucursal:this.codigo_sucursal,
                            bodega:this.getField('bodega').getValue(),
                            costo:this.getField('costo').getValue(),
                            codigo_articulo:this.getField('codigo_articulo').getValue()
                        }};
                        this.generalFormatPmv = { tipo_servicio: 'inve-asentarordenproduccion', operacion: 'enviarcorreo', operacion_tipo: 'consulta' };
                        this.service.send(
                        {
                            endpoint: this.constant.formConfiguration(),
                            method:'GET',
                            body: datos,
                            success: this.sucessValidaciones,
                            error: this.error_,
                            general: this.generalFormatPmv,
                            showMessage: false
                        });
                    }else if(this.accion === "modificar"){
                        this.getField("select_ubicacion").setError(false,"");
                        this.getField('grabar_agregar').setDisabled(true);
                        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está validando la información... `);
                        this.getField('confirmModalCustom').setClickDialog(()=>{});  
                        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                        this.getField('confirmModalCustom').toggle(true);
                        let datos={ datos: {
                            codigo_sucursal:this.codigo_sucursal,
                            bodega:this.getField('bodega').getValue(),
                            costo:this.getField('costo').getValue(),
                            codigo_articulo:this.getField('codigo_articulo').getValue()
                        }};
                        this.generalFormatPmv = { tipo_servicio: 'inve-asentarordenproduccion', operacion: 'enviarcorreo', operacion_tipo: 'consulta' };
                        this.service.send(
                        {
                            endpoint: this.constant.formConfiguration(),
                            method:'GET',
                            body: datos,
                            success: this.sucessValidaciones,
                            error: this.error_,
                            general: this.generalFormatPmv,
                            showMessage: false
                        });
                    }
                }else{
                    this.getField('grabar_agregar').setDisabled(true);
                    this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está validando la información... `);
                    this.getField('confirmModalCustom').setClickDialog(()=>{});  
                    this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                    this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                    this.getField('confirmModalCustom').toggle(true);
                    let datos={ datos: {
                        codigo_sucursal:this.codigo_sucursal,
                        bodega:this.getField('bodega').getValue(),
                        costo:this.getField('costo').getValue(),
                        codigo_articulo:this.getField('codigo_articulo').getValue()
                    }};
                    this.generalFormatPmv = { tipo_servicio: 'inve-asentarordenproduccion', operacion: 'enviarcorreo', operacion_tipo: 'consulta' };
                    this.service.send(
                    {
                        endpoint: this.constant.formConfiguration(),
                        method:'GET',
                        body: datos,
                        success: this.sucessValidaciones,
                        error: this.error_,
                        general: this.generalFormatPmv,
                        showMessage: false
                    });  
                }
            }else{
                this.alertGeneral.toggle(true, 'Debe seleccionar una ubicación.', 'error');
            }
        }
    }

    validacionesAgregar2(input){
        this.getField('grabar_agregar').setDisabled(true);
        this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está validando la información... `);
        this.getField('confirmModalCustom').setClickDialog(()=>{});  
        this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
        this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
        this.getField('confirmModalCustom').toggle(true);
        if(this.getField('codigo_articulo').valid()){
            let datos={ datos: {
                  sucursal:this.codigo_sucursal,
                  input:input,
                  bodega:this.getField('bodega').getValue(),
                  costo:this.getField('costo').getValue(),
                  codigo_articulo:this.getField('codigo_articulo').getValue(),
                  codigo_usuario:this.codigo_usuario
            }};
            this.generalFormatPmv = { tipo_servicio: 'inve-asentarordenproduccion', operacion: 'enviarcorreo', operacion_tipo: 'consulta' };
            this.service.send(
            {
                    endpoint: this.constant.formConfiguration(),
                    method:'GET',
                    body: datos,
                    success: this.sucessValidaciones,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage: false
            });
        }
    }

    sucessValidaciones(data)
    { 
        this.getField('confirmModalCustom').toggle(false);
        this.getField('grabar_agregar').setDisabled(false);
        if (data.estado_p === 200 && data.data.paso === "")
        { 
            if(data.data.costo_pro!==undefined){
                //pedir el input
                let costo_pro=data.data.costo_pro;
                if(costo_pro===0){
                    this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'El costo_pro_'+this.getField('bodega').getValue()+' es cero. ¿Está seguro de continuar?');
                    this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false);this.validacionesAgregar2(0) });
                    this.getField("confirmModalCustom").setVisibleCancel(false); // Para no mostrar el botón de cancelar en los ConfirmDialog
                    this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                    this.getField('confirmModalCustom').toggle(true);
                }else{
                    let valor_costo = Math.abs((costo_pro - this.getField('costo').getValue())/ costo_pro) * 100;
                    let margen_costo_promedio=data.data.margen_costo_promedio;
                    if (valor_costo > margen_costo_promedio) {
                    this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'El valor del costo sobrepasa el margen costo entrada. Margen costo entrada= '+margen_costo_promedio.toFixed(1)+'. Variación='+valor_costo.toFixed(4)+'. ¿Está seguro de continuar? ');
                    this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false);this.validacionesAgregar2(0) });
                    this.getField("confirmModalCustom").setVisibleCancel(false); // Para no mostrar el botón de cancelar en los ConfirmDialog
                    this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                    this.getField('confirmModalCustom').toggle(true);
                    }else{
                    this.validacionesAgregar2(0)
                    }
                }
            }else{
                return true;
            }
        }
        else 
        {
            if(data.estado_p===200 && data.data.paso==="true") {
                this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
                let datos = { datos: {
                    bodega_wms: this.wms_bodega,
                    sucursal:this.codigo_sucursal,
                    bodega:this.getField("bodega").getValue(),
                    codigo_articulo:this.getField("codigo_articulo").getValue(),
                    nombre_articulo1:this.getField("nombre_articulo1").getValue(),
                    ubicacion:this.getField("ubicacion").getValue(),
                    cantidad_unidad:String(this.getField("cantidad_unidad").getValue()),
                    costo:String(this.getField("costo").getValue()),
                    factor:String(this.getField("factor").getValue()),
                    cantidad_total:String(this.getField("cantidad_total").getValue()),
                    valor_item:String(this.getField("valor_item").getValue()),                
                    pantalla:"asentar",
                    accion:this.accion,
                    wms_nuevo:this.wms_nuevo,
                    codigo_usuario:this.codigo_usuario
                }};
                
                this.generalFormatPmv = { tipo_servicio: 'inve-asentarordenproduccion', operacion: 'grabaritem', operacion_tipo: 'consulta' };
                this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method:'GET',
                    body: datos,
                    success: this.successGrabarItem,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage:false
                });
            }
            else {
                let respuesta=Object.values(data.data.errores);
                let keys=Object.keys(data.data.errores);
                this.alertGeneral.toggle(true, 'Error (mensaje)' +keys + ' - ' + respuesta, 'error');
            }
        }
    }

    successGrabarItem(data){
        this.getField('confirmModalCustom').toggle(false);
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){
            this.accion="agregar"
            this.saldototal();
            this.limpiarcampos();
            this.alertGeneral.toggle(true, 'Registro grabado. ', 'success');
        }else if(data.estado_p ===404){
            let respuesta=data.data.errores.mensaje;
            this.getField('confirmModalCustom').setTitleAndContent('Mensaje', respuesta);
            this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); 
            if(this.wms_nuevo==="N"){
                this.limpiarcampos();
            }});
            this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
            this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
            this.getField('confirmModalCustom').toggle(true);
        }else{
            let respuesta=Object.values(data.data.errores);
            this.getField('confirmModalCustom').setTitleAndContent('Mensaje', respuesta);
            this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); this.limpiarcampos() });
            this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
            this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
            this.getField('confirmModalCustom').toggle(true);
        }
    }

    cargarUbicaciones(){
        let datos = { datos: {
            bodega:this.getField("bodega").getValue(),
            codigo_sucursal:this.lasucursal,
            codigo_articulo:this.getField("codigo_articulo").getValue()
        }};
        
        this.generalFormatPmv = { tipo_servicio: 'inve-asentarordenproduccion', operacion: 'cargarubicaciones', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successcargarUbicaciones,
            error: this.error_,
            general: this.generalFormatPmv,
            showMessage:false
        });
    }

    successcargarUbicaciones(data){
        if (data.estado_p === 200 )
        {
            let opciones = [{'text':'Ninguno','value':'','campos_cambian':{}}];
            data.data.forEach(item => {
                let dataOp = {}
                dataOp['value'] = item.id;
                dataOp['text'] = item.ubicacion_codigo;
                dataOp['campos_cambian'] = { ubicacion: item.ubicacion_codigo};
                opciones.push(dataOp);
            });
            this.getField('select_ubicacion').setOptions(opciones);

        }else {
            if(data.estado_p===404) {
                this.alertGeneral.toggle(true, 'No hay datos.', 'error');
            }
            else {
              let respuesta=Object.values(data.data.errores.mensaje);
              this.alertGeneral.toggle(true, 'Error (mensaje)' + respuesta, 'error');
            }
        }
    }

    grabarorden(){
        if(this.getField("codigo_sucursal").valid() && this.getField("nombre_sucursal").valid() 
        && this.getField("codigo_producto").valid() && this.getField("nombre_articulo").valid() && this.getField("cantidad").valid()
        && this.getField("bodega").valid() && this.getField("nombre_bodega").valid() && this.getField("unidad").valid() 
        && this.getField("total").valid() && this.getField("factura_compra").valid() && this.getField("nit").valid()
        && this.getField("sede").valid() && this.getField("nombre").valid()){
            if(parseInt(this.getField("total").getValue()) > 0){
                this.getField('confirmModalCustom').setTitleAndContent('Advertencia', `No recargue la página, por favor espere, se está generando la información... `);
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("."); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
                let datos = { datos: {
                    codigo_sucursal:this.getField("codigo_sucursal").getValue(),
                    sucursal:this.lasucursal,
                    bodega:this.getField("bodega").getValue(),
                    codigo_producto:this.getField("codigo_producto").getValue(),
                    cantidad:this.getField("cantidad").getValue(),
                    unidad:this.getField("unidad").getValue(),
                    numero:this.getField("numero").getValue(),
                    nit:this.getField("nit").getValue(),
                    sede:this.getField("sede").getValue(),
                    factura_compra:this.getField("factura_compra").getValue(),
                    wms_nuevo:this.wms_nuevo,
                    total:this.total,
                    fecha:this.getField("fecha").getValue(),
                    bodega_wms:this.wms_bodega,
                    exigefactura:this.exigefactura,
                    codigo_usuario:this.codigo_usuario,
                    fecha_fin:"now ()",
                    xdestino:this.destino,
                    costo_promedio_linea:this.costo_bodega,
                    costo_por_bodega: this.costo_promedio_linea
                }};
                
                this.generalFormatPmv = { tipo_servicio: 'inve-asentarordenproduccion', operacion: 'grabarasentar', operacion_tipo: 'consulta' };
                this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method:'GET',
                    body: datos,
                    success: this.successGrabarOrden,
                    error: this.error_,
                    general: this.generalFormatPmv,
                    showMessage:false
                });
            }else{
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'No hay items para grabar.');
                this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false);});
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }
        }else{
            this.getField('confirmModalCustom').toggle(false);
        }
    }

    successGrabarOrden(data){
        this.getField('confirmModalCustom').toggle(false);
        if(data.estado_p === 200){
            this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La orden de producción número: '+this.getField("numero").getValue() + ' fue asentada correctamente.');
            this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); this.limpiarTodo() });
            this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
            this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
            this.getField('confirmModalCustom').toggle(true);
        }else if(data.estado_p ===404){
            let respuesta=data.data.errores.mensaje;
            if(data.data.existe === "1"){
                this.numero_entrada="";
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', 'La orden de producción con el número '+this.getField("numero").getValue() +' ya ha sido asentada.');
                this.getField('confirmModalCustom').setClickDialog(() => {this.getField("numero").setValue(""); this.getField('confirmModalCustom').toggle(false); this.limpiarTodo()});
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("Confirmar"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }else{
                this.getField('confirmModalCustom').setTitleAndContent('Mensaje', respuesta);
                this.getField('confirmModalCustom').setClickDialog(() => { this.getField('confirmModalCustom').toggle(false); });
                this.getField("confirmModalCustom").setVisibleCancel(true); // Para no mostrar el botón de cancelar en los ConfirmDialog
                this.getField("confirmModalCustom").setButtonConfirm("OK"); // Para renombrar el botón de "confirmar" en los ConfirmDialog – popup
                this.getField('confirmModalCustom').toggle(true);
            }
        }else{
            let respuesta=data.data.errores.mensaje;
            this.alertGeneral.toggle(true, 'Error '+respuesta, 'error');
        }
    }

    limpiarTodo(){
        this.getField("codigo_producto").setValue("");
        this.getField("nombre_articulo").setValue("");
        this.getField("codigo_sucursal").setValue("");
        this.getField("nombre_sucursal").setValue("");
        this.getField("numero").setValue("");
        this.getField("bodega").setValue("");
        this.getField("nombre_bodega").setValue("");
        this.getField("unidad").setValue("");
        this.getField("fecha").setValue("");
        this.getField("nit").setValue("");
        this.getField("sede").setValue("");
        this.getField("nombre").setValue("");
        this.getField("cantidad").setValue("");
        this.getField("total").setValue("");
        this.gridOptionsComponentes['rowData'] = [];
        this.getField('rejilla').toggle(false);
        this.initForm();
    }

    limpiar(){
        this.comenzo=false;
        this.getField("total").setValue("");
        this.gridOptionsComponentes['rowData'] = [];
        this.getField('rejilla').toggle(false);
    }

    traercodigo(){
        if(this.getField('codigo_articulo').getValue() !== '' && this.accion !== "modificar"){
            let datos = { datos: {
                codigo_usuario:this.codigo_usuario,
                codigo_articulo: this.getField('codigo_articulo').getValue(),
                ubicacion:this.getField("ubicacion").getValue()
            }};
        
            this.generalFormatPmv = { tipo_servicio: 'inve-asentarordenproduccion', operacion: 'existe_articulo', operacion_tipo: 'consulta' };
            this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method:'GET',
                body: datos,
                success: this.successTraerDatos,
                error: this.error_,
                general: this.generalFormatPmv,
                showMessage: false
            });
        }else{
            this.getField('confirmModalCustom').toggle(false);
        }
    }

    successTraerDatos(data){
        if (data.estado_p === 200 )
        {           
            this.getField('confirmModalCustom').toggle(false);
            if (data.data.length >= 1) {
                this.getField('confirmModalCustom').setTitleAndContent('Advertencia', 'El código '+data.data[0].codigo+' ya existe, ¿Desea modificarlo?');
                this.getField('confirmModalCustom').setClickDialog(()=>{this.entro=true; this.Modificar(data.data[0].codigo,data.data[0].nombre,data.data[0].factor,data.data[0].cantxund,data.data[0].cant_utilizada,data.data[0].costo,data.data[0].costo_item,data.data[0].ubicacion)});
                this.getField('confirmModalCustom').setButtonConfirm('Confirmar');
                this.getField('confirmModalCustom').setClickCancelDialog(() => {
                    this.validarcancelarconfirmar();
                    this.getField('confirmModalCustom').toggle(false);
                });
                this.getField("confirmModalCustom").setVisibleCancel(false);
                this.getField('confirmModalCustom').toggle(true);
            }
        }else{
            this.getField('confirmModalCustom').toggle(false);
        }
    }

    validarcancelarconfirmar(){
        if(this.entro=== false){
            this.limpiarcampos();
        }
    }
   
}
FormJaivana.addController("inve-asentarordenproduccion", CustomAsentarOrdenProduccion);
export default CustomAsentarOrdenProduccion;